import { FEET, HAWAIIAN, METERS } from '@surfline/web-common';

const conditionIsFlat = (max: number, units: string): boolean =>
  !max ||
  !!(units && units?.toUpperCase?.() === FEET && max <= 0.5) ||
  !!(units && units?.toUpperCase?.() === METERS && max <= 0.2) ||
  !!(units && units?.toUpperCase?.() === HAWAIIAN && max <= 0);

export default conditionIsFlat;
